// src/b2b/components/RoomCategories.jsx
import React, { useMemo } from 'react';
import { aciFromItem, formatACI } from '../utils/aci';

const eurFmt = (n, currency = 'EUR') =>
  new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(Number(n || 0));

/**
 * Déplie le combo: chaque ligne qty=N devient N chambres identiques,
 * et l’ACI (A,C,I) est lu via allocation/description/value.
 */
function expandComboByACI(combo = []) {
  const out = [];
  for (const it of Array.isArray(combo) ? combo : []) {
    const qty = Math.max(1, Number(it.qty || 1));
    const aci = aciFromItem(it);
    const unit = Number(
      it.unitTotal ?? it?.price?.unit ?? (it?.price?.total && qty ? it.price.total / qty : 0),
    );
    const currency = it?.price?.currency || it?.currency || 'EUR';
    const desc = it.desc || it.description || it.code || 'Chambre';
    const variant = it.variant || 'Standard';

    for (let i = 0; i < qty; i++) {
      out.push({ desc, aci, unit, currency, variant });
    }
  }
  return out;
}

export default function RoomCategories({ combo = [] }) {
  if (!Array.isArray(combo) || combo.length === 0) return null;

  // 1 ligne = 1 chambre (indépendamment de baseType)
  const rooms = useMemo(() => expandComboByACI(combo), [combo]);
  console.log('%csrc\b2bcomponentsRoomCategories.jsx:38 rooms', 'color: #007acc;', rooms);
  const currency =
    rooms.find((r) => r.currency)?.currency ||
    rooms.find((r) => r.price?.currency)?.price?.currency ||
    'EUR';

  return (
    <div className="vstack gap-3 mt-3">
      {rooms.map((r, i) => (
        <div key={i} className="border rounded p-3 bg-light-subtle mt-2">
          <div className="fw-semibold mb-1">{`Chambre ${i + 1} : ${formatACI(r.aci)}`}</div>

          <div className="small text-secondary mb-1">
            {/* {(r.variant && r.variant !== 'Standard') ? r.variant : 'Autre'} */}
            {r.desc ? <span className="text-muted"> {r.desc}</span> : null}
          </div>

          <div className="d-flex justify-content-between gap-3 small">
            <span>
              Prix unitaire : <strong>{eurFmt(r.unit, currency)}</strong>
            </span>
          </div>
        </div>
      ))}

      <div className="d-flex justify-content-between border-top pt-3 mt-2">
        <div className="text-muted small">Total sélection</div>
        <div className="fw-semibold">
          {eurFmt(
            rooms.reduce((s, r) => s + Number(r.unit || 0), 0),
            currency,
          )}
        </div>
      </div>
    </div>
  );
}
